var BillingMixins = {
    // subscribeUrl (str)
    // billingInfoUrl (str)
    // billingInfoParams (function return obj)
    // updateCustomerUrl (str)
    // reinstateSubscriptionUrl (str)
    // cancelStripeSubscriptionUrl (str)
    // cancelPaypalSubscriptionUrl (str)

    updateCustomer: function (data, callback) {
        return this.post(this.updateCustomerUrl, data, callback);
    },
    reinstateSubscription: function (data, callback) {
        return this.post(this.reinstateSubscriptionUrl, data, callback);
    },
    payDelinquentStripeInvoice: function (data, callback) {
        return this.post('pay-delinquent-stripe-invoice', data, callback);
        
    },
    cancelIncompleteStripeSubscription: function (data, callback) {
        return this.post('cancel-incomplete-stripe-subscription', data, callback);
        
    },
    cancelStripeSubscription: function (data, callback) {
        return this.post(this.cancelStripeSubscriptionUrl, data, callback);
    },
    cancelPaypalSubscription: function (data, callback) {
        return this.post(this.cancelPaypalSubscriptionUrl, data, callback);
    },
    getBillingInfo: function (callback, delay, failCount) {
        this.session.backend.get(this.billingInfoUrl, this.billingInfoParams(), _.bind(function (response) {
            if (response.error || response.success === false) {
                if (
                    failCount >= 10 ||
                    response.message == 'not_found' ||
                    response.message == 'auth' ||
                    response.message == 'database_down'
                ) {
                    this.trigger('billingInfoError', response, {
                        failCount: failCount,
                        gave_up: true
                    });
                    if (callback) {
                        callback(response);
                    }
                } else {
                    if (delay) {
                        delay *= 2;
                        if (delay > 5000) {
                            delay = 5000;
                        }
                    } else {
                        delay = 500;
                    }
                    if (failCount) {
                        failCount++;
                    } else {
                        failCount = 1;
                    }
                    this.trigger('billingInfoError', response, {
                        failCount: failCount,
                        retry_delay: delay
                    });
                    setTimeout(_.bind(function () {
                        this.getBillingInfo(callback, delay, failCount);
                    }, this), delay);
                }
            } else {
                var data = {
                    'billing': response.billing,
                    'paypal_billing': response.paypal_billing,
                    'android_billing': response.android_billing,
                    'subscription_oneoff': response.subscription_oneoff,
                    
                    'charges': response.charges,
                    'invoices': response.invoices,
                    'invoice_items': response.invoice_items,
                    'paypal_charges': response.paypal_charges,
                    'paypal_oneoff_charges': response.paypal_oneoff_charges,
                    'android_charges': response.android_charges,
                    'android_oneoff_charges': response.android_oneoff_charges,
                    
                    'subscriptions': response.subscriptions
                };
                this.set(data, {silent:true});
                this.trigger('billingUpdate');
                if (callback) {
                    callback(response);
                }
            }
        }, this));
    },
    subscribe: function (data, callback) {
        return this.post(this.subscribeUrl, data, callback);
    },
    hasActiveStripeSubscription: function () {
        var b = this.get('billing');
        var sub = b ? b.subscription : this.get('subscription');
        var active = _.include(
            ['active', 'trialing', 'past_due'],
            sub
        );
        if (b) {
            return active && !b.cancel_at_period_end;
        } else {
            return active;
        }
    },
    hasActivePaypalSubscription: function () {
        return this.hasSubscribedPaypal() && this.get('paypal_billing').subscription == 'active';
    },
    hasActiveAndroidSubscription: function () {
        return this.hasSubscribedAndroid() && this.get('android_billing').subscription == 'active';
    },
    hasActiveOneOffSubscription: function () {
        var s = this.get('subscription_oneoff');
        return !!(s && s.active);
    },
    hasActivePaypalMonthlySubscription: function () {
        return this.hasActivePaypalSubscription() && this.get('paypal_billing').interval == 'month';
    },
    hasActiveStripeMonthlySubscription: function () {
        return this.hasActiveStripeSubscription() && this.get('billing').interval == 'month';
    },
    hasActiveAndroidMonthlySubscription: function () {
        return this.hasActiveAndroidSubscription() && this.get('android_billing').interval == 'month';
    },
    hasActiveRecurringSubscription: function () {
        return this.hasActiveStripeSubscription()
            || this.hasActivePaypalSubscription()
            || this.hasActiveAndroidSubscription();
    },
    hasActiveSubscription: function () {
        return this.hasActiveRecurringSubscription()
            || this.hasActiveOneOffSubscription();
    },
    hasActiveMonthlySubscription: function () {
        return this.hasActiveStripeMonthlySubscription()
            || this.hasActivePaypalMonthlySubscription()
            || this.hasActiveAndroidMonthlySubscription();
    },
    isStripeSubscriptionPastDue: function () {
        var b = this.get('billing');
        var sub = b ? b.subscription : this.get('subscription');
        return sub == 'past_due';
    },
    isStripeSubscriptionCanceled: function () {
        if (!this.hasSubscribedStripe()) {
            return false;
        }
        var b = this.get('billing');
        if (b && (_.include(['canceled', 'incomplete_expired'], b.subscription) || b.cancel_at_period_end)) {
            return true;
        }
        return false;
    },
    isStripeSubscriptionUnpaid: function () {
        var b = this.get('billing');
        var sub = b ? b.subscription : this.get('subscriptions');
        return _.include(
            ['unpaid', 'incomplete'],
            sub
        );
    },
    isPaypalSubscriptionCanceled: function () {
        return this.hasSubscribedPaypal() && this.get('paypal_billing').subscription == 'cancelled';
    },
    isPaypalSubscriptionExpired: function () {
        return this.hasSubscribedPaypal() && this.get('paypal_billing').subscription == 'expired';
    },
    isOneOffSubscriptionExpired: function () {
        var s = this.get('subscription_oneoff');
        if (!s) {
            return false;
        }
        return s.active === false;
    },
    isSubscriptionCanceled: function () {
        return this.isStripeSubscriptionCanceled()
            || this.isPaypalSubscriptionCanceled()
            || this.isOneOffSubscriptionExpired();
    },
    isSubscriptionUnpaid: function () {
        return this.isStripeSubscriptionUnpaid()
            || this.isPaypalSubscriptionExpired()
            || this.isOneOffSubscriptionExpired();
    },
    hasSubscribedStripe: function () {
        if (
            this.has('billing') ||
            (
                this.get('subscriptions') &&
                this.get('subscriptions').stripe &&
                this.get('subscriptions').stripe.length
            )
        ) {
            return true;
        }
        return false;
    },
    hasSubscribedPaypal: function () {
        return this.has('paypal_billing');
    },
    hasSubscribedAndroid: function () {
        return this.has('android_billing');
    },
    hasSubscribedOneOff: function () {
        return this.has('subscription_oneoff');
    },
    hasSubscribed: function () {
        return this.hasSubscribedStripe()
            || this.hasSubscribedPaypal()
            || this.hasSubscribedAndroid()
            || this.hasSubscribedOneOff();
    }
};


module.exports = BillingMixins;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/mixins/billingmixins.js
// module id = uUaF
// module chunks = 1